export default __webpack_public_path__ + "static/aaditya-first-pr-ef831874a89d5f16912d51bf25ae9d2f.webp";